import { defineComponent } from "vue";
import InputBaseControl from "./InputBaseControl";
export default defineComponent({
  name: "TextBox",
  extends: InputBaseControl,
  watch: {
    "state.value": {
      handler(newValue, oldValue) {
        let maxLength = this.mtdt.LDT.MaxLength ? this.mtdt.LDT.MaxLength : 0;
        if (newValue && maxLength > 0 && newValue.length > maxLength) {
          this.state.value = newValue.substring(0, maxLength);
        }
      },
      deep: true,
      //immediate:true,
    },
  },
});
